var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 0C400 0 288 32 288 176v112c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v256c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V176C128 32 16 0 0 0v176c0 44.2 26.7 82.8 64 97.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V352h32v128c0 17.7 14.3 32 32 32s32-14.3 32-32V273.3c37.3-14.5 64-53.1 64-97.3V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenActive);
export default __webpack_public_path__ + "static/media/kitchen-active.2abed192739459a2bc7ec79c047c7f41.svg";
export { ForwardRef as ReactComponent };